import { render, staticRenderFns } from "./RoomCareStatistics.vue?vue&type=template&id=6a72e1da&scoped=true&"
import script from "./RoomCareStatistics.vue?vue&type=script&lang=ts&"
export * from "./RoomCareStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./RoomCareStatistics.vue?vue&type=style&index=0&id=6a72e1da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72e1da",
  null
  
)

export default component.exports